export default
  {
    RH: "Recursos Humanos",
    ST: "Serviço de Terceiros",
    MC: "Materiais de Consumo",
    MP: "Materiais Permanentes",
    VD: "Viagens e Diárias",
    OU: "Outros"
  }